// @flow
import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import { Range, Flex } from '../'
import { ControllerError } from './'

type RangeControllerProps = {
  name: string,
  label?: string,
  defaultValue?: number,
  [key: string]: any
}

const RangeController = ({ name, defaultValue, ...props }: RangeControllerProps) => {
  const { errors } = useFormContext()
  return (
    <Flex column>
      <Controller
        defaultValue={defaultValue}
        name={name}
        render={({ field: { value, onChange } }) => (
          <Range id={`${name}-range`} value={value} onChange={onChange} {...props} />
        )}
      />
      <ControllerError errors={errors} name={name} />
    </Flex>
  )
}

export { RangeController }
